// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__bAjF6","left":"InfoRow_left__FEUHz"};